import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "swiper/swiper-bundle.css";
import * as Sentry from "@sentry/react";

Sentry.init({
	dsn: import.meta.env.VITE_SENTRY_DSN,

	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],

	tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
	replaysOnErrorSampleRate: 1.0,
	replaysSessionSampleRate: 0.1,
});

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
